const ACTION_GET_CONTACT_LIST = 'ACTION_GET_CONTACT_LIST'
const ACTION_GET_CONTACT_LIST_SUCCESS = 'ACTION_GET_CONTACT_LIST_SUCCESS'

export { ACTION_GET_CONTACT_LIST, ACTION_GET_CONTACT_LIST_SUCCESS }
